<template>
  <div class="background">
    <div class="spinner-container" v-if="loading">
      <spinner-el class="spinner"/>
    </div>
    <div class="container" v-else>
      <div class="reset-password">
        <div class="reset-password__title">
          New password
        </div>
          <icon-base class="reset-password__close" red @click.native="closeForm">
            <icon-cross/>
          </icon-base>
        <div class="reset-password__wrap">
          <div class="reset-password__notice">
            Please enter your new password:
          </div>
            <form novalidate @submit.stop.prevent="tryToSendForm">
              <input-el
                class="reset-password__password"
                type="password"
                name="password"
                inputId="password"
                placeholder="Enter your password"
                label="New password"
                @input="serverFieldErrors.password = null"
                v-model="$v.formData.password.$model"
                :error="$v.formData.password.$error"
              />
              <input-el
                class="reset-password__confirm-password"
                type="password"
                name="passwordConfirm"
                inputId="password-Confirm"
                placeholder="Repeat your password"
                label="One more time"
                @input="serverFieldErrors.confirmPassword = null"
                v-model.trim="$v.formData.confirmPassword.$model"
                :error="$v.formData.confirmPassword.$error"
              />

              <button-el left red large class="reset-password__btn" :disabled="requestInProgress">
                Continue
                <icon-base slot="icon" :red="!requestInProgress" :grey="requestInProgress">
                  <icon-check />
                </icon-base>
              </button-el>
            </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
// import loginModalTabs from 'src/models/LoginModalTabs';
import validateFormMixin from 'src/mixins/validateForm';
import { IconCheck, IconCross } from 'Icons';

export default {
  data: () => ({
    loading: true,
    requestInProgress: false,
    formData: {
      password: '',
      confirmPassword: '',
      queryToken: '',
    },
    serverFieldErrors: {
      password: {},
      confirmPassword: {},
    },
  }),
  methods: {
    tryToSendForm() {
      this.validateForm(null, this.resetPassword);
    },
    closeForm() {
      this.$router.replace('/all-currencies');
    },
    resetPassword() {
      this.requestInProgress = true;
      const {
        password,
        confirmPassword,
        queryToken,
      } = this.formData;
      this.$apiService.resetPassword(password, confirmPassword, queryToken).then(() => {
        // this.$router.replace('/all-currencies');
        // this.toggleLoginModal({ val: true, activeTab: loginModalTabs.login });
        this.$router.replace('/reset-password/success');
      }).catch((errors) => {
        if (errors.fieldErrors) {
          this.serverFieldErrors = errors.fieldErrors;
        }
      }).finally(() => {
        this.requestInProgress = false;
      });
    },
    ...mapActions('settings', [
      'toggleLoginModal',
    ]),
  },
  mixins: [
    validateFormMixin,
  ],
  validations: {
    formData: {
      password: {
        required,
        serverError() {
          return !(this.serverFieldErrors && this.serverFieldErrors.password);
        },
      },
      confirmPassword: {
        required,
        sameAs: sameAs('password'),
        serverValidity() {
          return !(this.serverFieldErrors && this.serverFieldErrors.confirmPassword);
        },
      },
    },
  },
  components: {
    IconCheck,
    IconCross,
  },
  mounted() {
    const token = this.$route.query.token;
    if (!token) {
      this.$router.replace('/reset-password/token-invalid');
      return;
    }
    this.$apiService.verifyToken(token).then(() => {
      this.formData.queryToken = token;
      this.loading = false;
    }).catch(() => {
      this.$router.replace('/reset-password/token-invalid');
    });
  },
};
</script>


<style lang="scss" scoped>
  .background {
    @include background;
  }
  .container {
    @include container;
    max-width: 430px;
    background: $white-color2;
    border-radius: 5px;
  }

  .reset-password {
    padding-bottom: 30px;
    box-shadow: 10px 10px 30px $black-color4;
    position: relative;

    &__title {
      @include font(24px, $black-color1, 500);
      border-bottom: 1px solid $white-color5;
      padding: 23px 29px 31px;
    }

    &__close {
      cursor: pointer;
      position: absolute;
      right: 30px;
      top: 23px;
    }

    &__wrap {
      padding: 0 31px;
    }

    &__btn {
      padding: 11px 9px 10px 19px;
    }

    &__notice {
      @include font(13px, $black-color1);
      line-height: 21px;
      margin-top: 25px;
      margin-bottom: 34px;
    }

    &__confirm-password {
      margin-top: 11px;
      margin-bottom: 29px;
    }
  }

  .spinner {
    margin: auto;
    position: relative;
    top: -120px;
  }

  .spinner-container {
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/ResetPassword.vue